<wiz-vgroup width="100%" height="100%" padding="0px">
  <wiz-hgroup *ngIf="showHeader" verticalAlign="end" gap="10">
    <wiz-icon #btnConf style="cursor: pointer; font-size: 20px" (click)="showSettingsPop()">settings</wiz-icon>
    <wiz-hgroup width="100%" style="overflow: auto"><ng-container #containerFilter></ng-container></wiz-hgroup>
  </wiz-hgroup>
  <wiz-ag-grid #agGrid width="100%" height="100%" 
  class="ag-theme-alpine"
  [frameworkComponents]="gridFrameworkComponents"
  [wizDatasource]="mainDS"
  [columnDefs]="columns"
  [gridOptions]="gridOptions"
  [wizRowSelection]="selectionMode"
  [customRowGroupRenderer]="customRowGroupRenderer"
  [wizShowGroup]="showRowGroup"
  (wizCellEdit)="onCellEdit($event)"
  (wizCellChecked)="onCellChecked($event)"
  (wizGroupClicked)="onRowGroupEvent($event)"
  (collapseOrExpandGroups)="collapseOrExpandGroups($event)"
  ></wiz-ag-grid>
</wiz-vgroup>
